<template>
    <img src="/images/logo-intimateinteractive-220x50.png">
</template>
